import type { Impact } from '@product-portal/shared';
import { IMPACT_LABELS } from '@/lib/labels';
import { Pill } from './pill';

const IMPACT_CLASSES: Record<Impact, string> = {
  blocking: 'bg-impact-blocking text-impact-blocking-foreground',
  annoying: 'bg-impact-annoying text-impact-annoying-foreground',
  minor: 'bg-impact-minor text-impact-minor-foreground',
};

/** Declared (requester) or retained (PO) impact. */
export function ImpactTag({ impact }: { impact: Impact }) {
  return <Pill className={IMPACT_CLASSES[impact]}>{IMPACT_LABELS[impact]}</Pill>;
}
